<template>
    <el-dialog :title="title" :visible="isShow" center width="70%" :key="group_id" :before-close="handleClose">
        <relation-form ref="form" 
                :key="key_time" 
                :group_id="group_id" 
                :service="service" 
                :customer-id="customerId"
                @handleClose="handleClose"  
                @removeAccount="removeAccount" 
                @relationAccount="relationAccount"
                :already-relation="alreadyRelation"
                :schoolId="schoolId"
            >
        </relation-form>
    </el-dialog>
</template>
<style>
    .cell {
        box-sizing: border-box;
        white-space: normal;
        word-break: break-all;
        line-height: 23px;
    }
</style>
<script>
    import RelationForm from "~/views/customer/relationForm.vue";
    import Pagination from "~/widgets/Pagination.vue";

    export default {
        components: {
            Pagination,
            RelationForm
        },
        data() {
            return {
                key_time: 1,
            }
        },
        props: {
            //产品服务
            service: {
                required: true
            },
            //标题
            title: {
                required: true
            },
            //客户id
            customerId: {
                required: true,
            },
            //是否弹窗
            isShow: {
                required: true
            },
            //用户组id
            group_id: {
                required: false
            },
            alreadyRelation: {
                required: false,
            },
            schoolId: {
                type: String,
                required:false
            }
        },
        watch:{
          'isShow':function (value) {
              if(value){
                  console.log('i am in');
                  ++this.key_time;
              }else{
                  console.log('i am out');
                  //组件销毁
                  this.$refs['form'].destroy()
              }
          }
        },
        methods: {
            removeAccount(data) {
                this.$emit('removeAccount', data);
            },
            relationAccount(data) {
                this.$emit('relationAccount', data);
            },
            handleClose() {
                this.$emit('handleClose', false)
            },
        }
    }
</script>




// WEBPACK FOOTER //
// src/views/customer/dialog/relationDialog.vue